import KpiCard from './KpiCard';
import { KpiCardsProps } from './types';

export default KpiCard;
export type { KpiCardsProps };
